var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 9,
    fill: "#00CA71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3677 10.0622L11.3892 6.36113L11.3892 6.36112C11.3902 6.18731 11.5316 6.04593 11.7054 6.04492L12.2083 6.042L12.2083 6.042L12.2089 6.142L11.3677 10.0622ZM11.3677 10.0622L7.22582 5.92025C7.10232 5.79675 6.90251 5.79909 6.77958 5.92202L6.4219 6.2797C6.29897 6.40263 6.29663 6.60244 6.42013 6.72594L10.562 10.8679L6.86099 10.8893C6.68718 10.8903 6.54581 11.0317 6.54478 11.2055V11.2055L6.54186 11.7085C6.54085 11.8832 6.68201 12.0243 6.85672 12.0233H6.85673L12.1761 11.9924C12.3499 11.9914 12.4913 11.85 12.4923 11.6762L12.4923 11.6762L12.5232 6.35687C12.5232 6.35686 12.5232 6.35686 12.5232 6.35686L11.3677 10.0622Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayInvoice);
export default __webpack_public_path__ + "static/media/pay-invoice.43e6ef6a.svg";
export { ForwardRef as ReactComponent };